import { deepMergeObjects, deepMergeObjectsWithIgnore } from '@/utils/deepMergeObjects'
import { hasTargetKey } from '@/utils/hasTargetKey'
import { hexToRgb, blendColor } from '@/assets/js/hexToRgba'
import { filterDefaultCustomReportGlobalConfig } from './defaultCustomReportGlobalConfig'
import router from '../../router/index'
// 【自定义报告】模块
const customReport = {
  state: {
    // 当前ID下的报告的整体配置，保存为草稿，历史记录时需要的参数
    reportOverallInfo: {},
    // 左侧报告选中项
    reportModuleSelected: '',
    // 左侧【报告模块配置】
    reportModuleConfig: [],
    // 右侧【整体配置】
    globalConfig: {
      // 封面配置
      reportCover: {
        // 封面数据列表
        reportCoverList: [],
        // 当前选中的封面
        currentReportCover: {},
      },
      // 封面LOGO配置
      reportLogo: {
        // 封面数据列表，为了以后可以扩展，用数组存储
        reportLogoList: [],
        // 当前选中的LOGO封面
        currentReportLogo: {},
        // LOGO位置
        logoPosition: '中上',
        // logo大小
        logoSize: 54,
        // logo大小配置对象
        logoSizeConfig: {
          checkLogoSize: '40.5',
          checkLogoSizeObject: {
            label: '54px',
            ptValue: '40.5',
            pxValue: '54',
          },
        },
        logoPositionConfig: {
          checkClientX: '257',
          checkClientY: '235',
          useCheckPositionType: '',
        },
        // 报告标题
        reportTitle: '报告标题',
        // 报告标题，配置项
        reportTitleConfig: {
          // 报告标题，距离X轴的距离
          checkClientX: '130',
          // 报告标题，距离Y轴的距离
          checkClientY: '330',
          // 报告标题位置类型，【 level_center 水平居中 】【 vertical_center 垂直居中 】【 ...扩展 】
          useCheckPositionType: 'level_center',
          // 报告标题，字号的大小，这里的字号是pt，不是px
          checkFontSize: '67.5',
          // 报告标题，字号的大小对象
          checkFontSizeObject: { label: '90px', ptValue: '67.5', pxValue: '90' },
          // 报告标题，文字颜色
          checkFontColor: '#ffffff',
        },
        isUseIndustrySubTitle: true,
        // 报告行业子标题
        reportIndustrySubTitleConfig: {
          checkClientX: '73',
          checkClientY: '688',
          useCheckPositionType: '',
          checkFontSize: '33.75',
          checkFontSizeObject: { label: '45px', ptValue: '33.75', pxValue: '45' },
          checkFontColor: '#ffffff',
        },
        // 渠道企业名称
        channelCompanyName: 'xxxx科技有限公司',
        // 渠道企业名称配置
        channelCompanyNameConfig: {
          checkClientX: '257',
          checkClientY: '235',
          useCheckPositionType: 'level_center',
          checkFontSize: '24',
          checkFontSizeObject: { label: '32px', ptValue: '24', pxValue: '32' },
          checkFontColor: '#060E7D',
        },
        // 检测企业所有的配置
        checkEnterprise: {
          checkClientX: '300',
          checkClientY: '600',
          useCheckPositionType: 'level_center',
          checkFontSize: '12',
          checkFontSizeObject: { label: '16px', ptValue: '12', pxValue: '16' },
          checkFontColor: '#ffffff',
        },
        // 是否显示，报告生成时间
        isUseReportCreateTime: true,
        // 报告生成时间粒度
        reportCreateTimeGrain: 'grain_second',
        // 报告生成时间粒度，format格式值
        reportCreateTimeFormat: 'YYYY-MM-DD HH:mm:ss',
        // 后端java，需要的时间格式值
        javaReportCreateTimeFormat: 'yyyy-MM-dd HH:mm:ss',
        // 报告生成时间位置
        reportCreateTimePosition: {
          checkClientX: '275',
          checkClientY: '1000',
          useCheckPositionType: '',
          checkFontSize: '12',
          checkFontSizeObject: { label: '16px', ptValue: '12', pxValue: '16' },
          checkFontColor: '#ffffff',
        },
        // 检测企业，前置标题
        checkEnterprisePreTitle: '检测企业',
        // 报告生成时间，前置标题
        reportCreateTimePreTitle: '报告生成时间',
      },
      // 声明
      statementInfo: {
        label: '样式一',
        value: '1',
        img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/1684487120110/CIRTKUVQ20230519050535',
        isLabelSelect: true,
        textarea: '',
      },
      // 目录
      catalogueConfig: {
        label: '样式一',
        value: '1',
        img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/1684487120110/CIRTKUVQ20230519050535',
        isLabelSelect: true,
        selectModel: '1',
        // 是否显示页码
        isUsePageNumbers: false, // true启用，false禁用
      },
      // 概述
      summaryConfig: {
        label: '样式一',
        value: 1,
        isLabelSelect: true,
      },
      // 概述2
      summaryConfigTwo: {
        label: '样式一',
        value: 1,
        isLabelSelect: true,
      },
      // 主题色
      reportThemeColor: {
        // 当前选中的主题色
        currentReportThemeColor: '#ffffff',
        // 当前选中的主题色RGB格式
        currentReportThemeColorRGB: '56, 129, 248',
      },
      // 页头样式
      labelSelect: {
        label: '样式一',
        value: '1',
        img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/1684487120110/CIRTKUVQ20230519050535',
        isLabelSelect: true,
      },
      customUploadHeaderStyle: {
        img: '',
        type: 'customUpload',
        label: '自定义上传',
        value: '1000',
        imgConfig: {},
        isLabelSelect: true,
      },
      // 风险提示
      riskTip: {},
      // 风险提示的位置
      // 1. top 2. bottom 3.split
      riskTipPosition: 'top',
      // 模块解读
      moduleInterpretation: {
        colorConfig: '#999999',
        fontSizeConfig: '9',
        fontSizeConfigObject: { label: '12px', ptValue: '9', pxValue: '12' },
      },
      // 报告水印开关
      watermark: 'off',
      // 水印文字
      reportWatermark: '',
      // 是否使用logo，作为水印图片
      isUseReportWatermarkImage: false,
      // 水印图片
      reportWatermarkImage: '',
      // 报告页码
      pageNumber: 'on',
      // 是否使用法规
      isUseLawsRule: true, // true启用，false禁用
      // 法规配置
      lawsRuleConfig: {
        display_mode: 'disperse', // 【 concentrate 集中 disperse 分散 】
        label: '样式一',
        value: 1,
        isLabelSelect: true,
      },
      // 表格样式
      tableStyle: {
        label: '样式一',
        value: '1',
        img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/1684487120110/CIRTKUVQ20230519050535',
        isLabelSelect: false,
      },
      // 表格颜色配置
      tableColorConfig: {
        // 使用颜色的方式 使用主题色：themeColor  自定义颜色：customColor
        useColorType: 'themeColor',
        // 自定义表格颜色
        customTableColor: '#3881F8',
      },
      // 标题样式
      titleStyle: {
        title: '标题样式',
        selectType: 'tabSelect',
        config: [
          {
            tabName: '一级标题',
            value: 'tab1',
            tabSelect: false,
            tabList: [
              {
                label: '样式一',
                value: 'tab1_label1',
                img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/titleStyle_firstLevel1/OMBEHDEQ20230517032020',
                isLabelSelect: true,
              },
            ],
          },
        ],
      },
      // 页脚
      footerConfig: {
        // logo大小
        logoSize: 54,
        // logo大小配置对象
        logoSizeConfig: {
          checkLogoSize: '40.5',
          checkLogoSizeObject: {
            label: '54px',
            ptValue: '40.5',
            pxValue: '54',
          },
        },
        logoPositionConfig: {
          checkClientX: '257',
          checkClientY: '235',
          useCheckPositionType: '',
        },
        // 页脚封面数据列表
        footerCoverList: [],
        // 当前选中的页脚封面
        currentFooterCover: {},
        footerLogo: {},
        footerLogoImage: {},
        otherConfig: {
          label: '样式一',
          value: '1',
          img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/1684487120110/CIRTKUVQ20230519050535',
          isLabelSelect: true,
          contactNumber: '138568xxxxxxx',
          addressArea: '这是一段测试的地址',
          QRCodeDescription: '微信公众号',
        },
      },
    },
    // 树节点的实例对象
    treeRef: '',
    // 树节点，默认展开的 key
    defaultExpandedKeys: [],
    // 后端传递过来的配置项是否加载完毕
    isDataLoadEnd: false,
    // 模块数据
    storeComponentsMap: {},
  },
  getters: {
    // 获取模块数据
    getStoreComponentsMap(state) {
      return state.storeComponentsMap
    },
    // 获取 当前ID下的报告的整体配置，保存为草稿，历史记录时需要的参数
    getReportOverallInfo(state) {
      return state.reportOverallInfo
    },
    // 获取 左侧【报告模块配置】
    getReportModuleConfig(state) {
      return state.reportModuleConfig
    },
    // 获取 左侧选中的小木块【报告模块配置】
    getReportModuleSelected(state) {
      return state.reportModuleSelected
    },
    // 获取 右侧【整体配置】
    getGlobalConfig(state) {
      return state.globalConfig
    },
    // 获取树节点实例
    getTreeRef(state) {
      return state.treeRef
    },
    // 获取树节点 展开的 key
    getDefaultExpandedKeys(state) {
      return state.defaultExpandedKeys
    },
    // 判断后端数据是否加载完毕
    getIsDataLoadEnd(state) {
      return state.isDataLoadEnd
    },
  },
  mutations: {
    // 设置模块数据
    setStoreComponentsMap(state, config) {
      state.storeComponentsMap = config
    },
    // 设置数据是否加载完毕的
    setDataLoadEnd(state, config) {
      state.isDataLoadEnd = config
    },
    // 设置 当前ID下的报告的整体配置，保存为草稿，历史记录时需要的参数
    setReportOverallInfo(state, config) {
      state.reportOverallInfo = config
    },
    // 设置 左侧【报告模块配置】
    setReportModuleConfig(state, config) {
      state.reportModuleConfig = config
    },
    // 设置 右侧【被选中小模块】的数据
    setReportModuleSelected(state, config) {
      state.reportModuleSelected = config
    },
    // 设置 右侧【整体配置】
    setGlobalConfig(state, { type, value }) {
      // 处理历史数据用的，避免出问题，判断配置项中是否含有 checkBackgroundColor 的key，没有则表示是历史数据，就进行相应的默认配置
      if (type == 'reset') {
        state.globalConfig = filterDefaultCustomReportGlobalConfig(router.currentRoute.value.query.report_type)
      }
      if (type == 'all') {
        const hasCheckBackgroundColorKey = hasTargetKey(value, 'checkBackgroundColor')
        // 这是最新的逻辑
        state.globalConfig = filterDefaultCustomReportGlobalConfig(router.currentRoute.value.query.report_type, hasCheckBackgroundColorKey)
        deepMergeObjectsWithIgnore(state.globalConfig, value)
        // 这是之前的逻辑，如果出现错误，就使用下面的
        // state.globalConfig = deepMergeObjects(currentDefaultReportGlobalConfig, value)
      }
      // 封面配置
      if (type == 'reportCover') {
        // 封面数据列表
        // state.globalConfig.reportCover.reportCoverList = value
        // 当前选中的封面
        // state.globalConfig.reportCover.currentReportCover = value.find((v) => v.isSelected)
        state.globalConfig.reportCover.currentReportCover = value
      }
      // 封面logo配置
      if (type == 'reportLogo') {
        // 封面数据列表
        state.globalConfig.reportLogo.reportLogoList = value
        // 当前选中的封面
        state.globalConfig.reportLogo.currentReportLogo = value[0]
      }
      // 封面logo大小
      if (type == 'logoSizeConfig') {
        state.globalConfig.reportLogo.logoSizeConfig = value
      }
      // 封面【logo配置】【报告标题】【渠道企业名称】
      if (type == 'reportLogoConfig') {
        // 封面数据列表
        state.globalConfig.reportLogo = { ...state.globalConfig.reportLogo, ...value }
      }
      // 封面【logo配置】【 检测企业的所有配置 】
      if (type == 'checkFontSizeObject') {
        // 封面数据列表
        state.globalConfig.reportLogo.checkEnterprise.checkFontSizeObject = value
      }
      // Logo位置
      if (type == 'logoPosition') {
        state.globalConfig.reportLogo.logoPosition = value
      }
      // 报告标题位置，X
      if (type == 'reportTitleConfigCheckClientX') {
        state.globalConfig.reportLogo.reportTitleConfig.checkClientX = value
      }
      // 报告标题位置，Y
      if (type == 'reportTitleConfigCheckClientY') {
        state.globalConfig.reportLogo.reportTitleConfig.checkClientY = value
      }
      // 渠道企业名称位置，X
      if (type == 'channelCompanyNameConfigCheckClientX') {
        state.globalConfig.reportLogo.channelCompanyNameConfig.checkClientX = value
      }
      // 渠道企业名称位置，Y
      if (type == 'channelCompanyNameConfigCheckClientY') {
        state.globalConfig.reportLogo.channelCompanyNameConfig.checkClientY = value
      }
      // 渠道企业名称，字体大小
      if (type == 'channelCompanyNameConfigCheckFontSize') {
        state.globalConfig.reportLogo.channelCompanyNameConfig.checkFontSize = value
      }
      // 渠道企业名称，字体颜色
      if (type == 'channelCompanyNameConfigCheckFontColor') {
        state.globalConfig.reportLogo.channelCompanyNameConfig.checkFontColor = value
      }
      // 检测企业，距离X轴的距离
      if (type == 'checkClientX') {
        state.globalConfig.reportLogo.checkEnterprise.checkClientX = value
      }
      // 检测企业，距离Y轴的距离
      if (type == 'checkClientY') {
        state.globalConfig.reportLogo.checkEnterprise.checkClientY = value
      }
      // 报告生成时间，距离X轴的距离
      if (type == 'reportCreateTimePositionClientX') {
        state.globalConfig.reportLogo.reportCreateTimePosition.checkClientX = value
      }
      // 报告生成时间，距离Y轴的距离
      if (type == 'reportCreateTimePositionClientY') {
        state.globalConfig.reportLogo.reportCreateTimePosition.checkClientY = value
      }
      // 检测企业，前置标题
      if (type == 'checkEnterprisePreTitle') {
        state.globalConfig.reportLogo.checkEnterprisePreTitle = value
      }
      // 报告生成时间，前置标题
      if (type == 'reportCreateTimePreTitle') {
        state.globalConfig.reportLogo.reportCreateTimePreTitle = value
      }
      // 声明
      if (type == 'statementInfo') {
        state.globalConfig.statementInfo = value
      }
      // 目录
      if (type == 'catalogueConfig') {
        state.globalConfig.catalogueConfig = value
      }
      // 目录
      if (type == 'summaryConfig') {
        state.globalConfig.summaryConfig = value
      }
      // 主题色
      if (type == 'reportThemeColor') {
        // 当前选中的主题色
        state.globalConfig.reportThemeColor.currentReportThemeColor = value
        // 当前选中的主题色
        state.globalConfig.reportThemeColor.currentReportThemeColorRGB = hexToRgb(value)
        state.globalConfig.reportThemeColor.currentReportThemeColorPoint5 = blendColor(value, 0.05)
        state.globalConfig.reportThemeColor.currentReportThemeColorPoint8 = blendColor(value, 0.08)
        state.globalConfig.reportThemeColor.currentReportThemeColorPoint10 = blendColor(value, 0.1)
      }
      // 页头样式
      if (type == 'labelSelect') {
        // 当前选中的页头样式
        state.globalConfig.labelSelect = value
      }
      // 自定义上传的页头样式
      if (type == 'customUploadHeaderStyle') {
        // 当前选中的页头样式
        state.globalConfig.customUploadHeaderStyle = value
      }
      // 风险提示
      if (type == 'riskTip') {
        // 当前选中的风险提示
        state.globalConfig.riskTip = value
      }
      // 模块解读
      if (type == 'moduleInterpretation') {
        state.globalConfig.moduleInterpretation.colorConfig = value.colorConfig
        state.globalConfig.moduleInterpretation.fontSizeConfig = value.fontSizeConfig
      }
      if (type == 'fontSizeConfigObject') {
        state.globalConfig.moduleInterpretation.fontSizeConfigObject = value
      }
      // 报告水印
      if (type == 'watermark') {
        // 当前报告水印
        state.globalConfig.watermark = value
      }
      // 报告水印,文字
      if (type == 'reportWatermark') {
        // 当前报告水印
        state.globalConfig.reportWatermark = value
      }
      // 报告页码
      if (type == 'pageNumber') {
        state.globalConfig.pageNumber = value
      }
      // 法规
      if (type == 'isUseLawsRule') {
        state.globalConfig.isUseLawsRule = value
      }
      // 表格样式
      if (type == 'tableStyle') {
        // 当前选中的表格样式
        state.globalConfig.tableStyle = value
      }
      // 标题样式
      if (type == 'titleStyle') {
        // 当前选中的标题样式
        state.globalConfig.titleStyle = value
      }
      // 法规样式
      if (type == 'lawsRuleConfig') {
        // 当前选中的标题样式
        state.globalConfig.lawsRuleConfig = { ...state.globalConfig.lawsRuleConfig, ...value }
      }
      // 页尾样式【上传的Logo】
      if (type == 'footerLogo') {
        state.globalConfig.footerConfig.footerLogo = value[0]
      }
      // 页尾样式【上传的Logo】
      if (type == 'footerLogoImage') {
        state.globalConfig.footerConfig.footerLogoImage = value[0]
      }
      // 页尾样式
      if (type == 'footerConfig') {
        state.globalConfig.footerConfig.otherConfig = value
      }
      // 页尾封面背景样式
      if (type == 'footerCover') {
        // state.globalConfig.footerConfig.footerCoverList = value
        // 当前选中的页尾封面背景样式
        // state.globalConfig.footerConfig.currentFooterCover = value.find((v) => v.isSelected)
        state.globalConfig.footerConfig.currentFooterCover = value
      }
      // 页脚logo字体大小设置
      if (type == 'footerLogoSizeConfig') {
        state.globalConfig.footerConfig.logoSizeConfig = value
      }
      // 页脚logo位置设置
      if (type == 'footerLogoPositionConfig') {
        state.globalConfig.footerConfig.logoPositionConfig = value
      }
    },
    // 设置树节点的ref实例
    setTreeRef(state, config) {
      state.treeRef = config
    },
    // 设置 树节点，默认展开的 key
    setDefaultExpandedKeys(state, config) {
      state.defaultExpandedKeys = config
    },
  },
}
export default customReport
